import { render } from "./UserInactive.vue?vue&type=template&id=75e3487e"
import script from "./UserInactive.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInactive.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/User/UserInactive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75e3487e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75e3487e', __exports__)) {
    api.reload('75e3487e', __exports__)
  }
  
  module.hot.accept("./UserInactive.vue?vue&type=template&id=75e3487e", () => {
    api.rerender('75e3487e', render)
  })

}


export default __exports__